module.exports = __webpack_public_path__ + "src/assets/img/paper.63ad2fc9.jpg";